"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE_TRANSFORMATIONS = exports.PARAMETER_SHORT_TYPES = void 0;
// Upper case letters refer to dynamically sized types, lower case letters refer to statically sized types
exports.PARAMETER_SHORT_TYPES = {
    B: 'bytes',
    b: 'bytes32',
    S: 'string',
    // Type "string32" is not supported in solidity and we use bytes32 on chain instead. We need to create this
    // artificially made up type so that users can decide if they want their data encoded as short string or as raw bytes
    // value.
    s: 'string32',
    a: 'address',
    i: 'int256',
    u: 'uint256',
    f: 'bool',
};
// Type mapping is common for both encoding/decoding
exports.TYPE_TRANSFORMATIONS = {
    string32: 'bytes32',
};
//# sourceMappingURL=constants.js.map